module.exports = __webpack_public_path__ + "img/title_cover.a14c20a.png";